import React from 'react'


function Half2() 
{
  return (
    <div>
     
      <div className="container grid grid-cols-12 mx-10 mt-5">
        <div className='text col-span-6'>
          <p className='text-blue-900 mt-4 text-2xl'>WHY CHOOSE US</p>
          <p className='text-blue-900 text-bold text-4xl'>BOOSTS YOUR WEBSITE TRAFFIC!!</p>
          <p className='italic text-blue-900'>We are passionate about our work. Our designers stay ahead of the curve to provide engaging and user-friendly website designs to make your business standout. Our developers are committed to maintaining the highest web standards so that your site will withstand the test of time. We care about your business. That's why we work with you.  </p>
          <button class="bg-transparent mt-2 hover:bg-blue-500 text-blue-900 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
          Discover More
          </button>
        </div>  
            
            
            
            
          
        <div className='col-span-6'>
          
          
          
          
        </div>

        
        

      
      
      </div>
      
      
    
    </div>
  )
}

export default Half2
